module.exports = __webpack_public_path__ + "static/media/contact-default.03c86333.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/contact-default.svg
// module id = 996
// module chunks = 0